import React, { useState } from 'react';
import { Grid, Icon, Header, Form, Loader } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';

import Email from './Email';
import contactDuplicatesActions from 'actions/contact_duplicates';
import { useFieldArray } from 'react-hook-form';
import { RecordUtils } from 'utils';
import RecordEmailsForm from 'shared/forms/RecordEmailsForm';
import EmailUtil from 'utils/EmailUtil';
import EMAIL_TYPE_OPTIONS from 'shared/constants/EMAIL_TYPE_OPTIONS';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

const EmailsField = ({
    contact_id,
    account_id,

    shouldCheckDuplicates = true,
    noPadding,
    allowNoEmails,

    isEditing,

    control,
    watchedEmails,
    setError,
    clearErrors,
    isUpdating,
    spacing
}) => {
    const dispatch = useDispatch();

    const {
        mainEmails,
        nonMainEmails,
        isReadingEmails
    } = useSelector((state) => {
        const emails = state.contact_email.email ? state.contact_email.email.slice(0) : [];
        const mainEmails = emails.filter(email => email.main);
        const nonMainEmails = emails.filter(email => !email.main);
        return {
            mainEmails,
            nonMainEmails,
            isReadingEmails: state.contact_email.isReadingEmails,
        }
    })
    
    const [areOtherEmailsShown, setOtherEmailsShown] = useState(false);

    const onToggleOtherEmails = () => {
        setOtherEmailsShown(!areOtherEmailsShown);
    }

    const { fields: emailsToEdit, append: addEmail, remove: removeEmail, update: updateEmail } = useFieldArray({
        control,
        name: 'emails'
    });

    const checkDuplicates = (queryParameters) => {
        return dispatch(contactDuplicatesActions.checkDuplicates(queryParameters));
    }

    if (isReadingEmails) {
        return <Loader active />
    }

    return (
        !isEditing ? (
            <Grid.Row style={{marginTop: 2, marginBottom: 12}} verticalAlign='top' className={`ContactInfo__phoneValue ${noPadding ? 'ContactInfo__row' : ''}`}>
                <Grid.Column width={9} style={{ paddingRight: 0, flex: 1 }}>
                    <div>
                        {mainEmails.length <= 0 && (
                            <span>
                                <Icon name='envelope' size='small' color='grey' /> No main email
                            </span>
                        )}
                        {mainEmails.map(email => (
                            <div style={areOtherEmailsShown && nonMainEmails.length > 0 && spacing ? { marginBottom: 10 } : {}}>
                                <Email email={email.email} email_type={email.email_type} />
                            </div>
                        ))}
                        {areOtherEmailsShown && (
                            nonMainEmails.map(email => (
                                <div className='ContactInfo__fieldContainer'>
                                    <Email email={email.email} email_type={email.email_type} />
                                </div>
                            ))
                        )}
                    </div>
                </Grid.Column>
                <Grid.Column width={1} style={{ left: -15 }}>
                    {nonMainEmails.length > 0 && <Icon disabled={nonMainEmails.length <= 0} onClick={onToggleOtherEmails} bordered size='tiny' name={`caret ${areOtherEmailsShown ? 'down' : 'right'}`} link style={{ marginLeft: 5, fontSize: 9, borderRadius: 5 }} />}
                </Grid.Column>
                {isReadingEmails && (
                    <Loader active={isReadingEmails} />
                )}
            </Grid.Row>
        ) : (
            <Grid.Row style={spacing ? {marginTop: 12, marginBottom: 12} : {}}>
                <Grid.Column>
                    <Form size='mini' loading={isUpdating}>
                        <Header size='small' color='primary'>
                            <span>
                                <RestrictedView type="disabled" userPermission={account_id ? USER_PERMISSIONS.ACCOUNT_ADD : USER_PERMISSIONS.CONTACTS_ADD}>
                                    <Icon link onClick={() => { EmailUtil.onAddEmail({ value: '', type: EMAIL_TYPE_OPTIONS.keys.WORK, new: true }, emailsToEdit, addEmail) }} className='fas fa-plus-circle' color='primary' /> Emails
                                </RestrictedView>
                            </span>
                        </Header>
                        <RecordEmailsForm
                            control={control}
                            emails={emailsToEdit}
                            onRemove={(index) => {
                                RecordUtils.removeItem(watchedEmails, index, updateEmail, removeEmail);
                            }}
                            updateMain={(onChange) => {
                                RecordUtils.updateMain(watchedEmails, updateEmail, onChange);
                            }}
                            checkDuplicates={shouldCheckDuplicates ? checkDuplicates : () => { return [] }}
                            clearErrors={clearErrors}
                            contact_id={contact_id}
                            setError={setError}
                            allowNoEmails={allowNoEmails}
                            isForContact={true}
                        />
                    </Form>
                </Grid.Column>
            </Grid.Row>
        )
    );
};

export default EmailsField;
